import { MapTo } from '@adobe/aem-react-editable-components';
import PageRibbon, { PageRibbonEditConfig } from './PageRibbon';

export default MapTo('cob-corp-acquisition/components/creditonebank/page-ribbon')(PageRibbon, PageRibbonEditConfig);